import { useEffect, useReducer } from "react";
import detectPointer from "detect-pointer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./css/App.css";
import tuotelista from "./json/tuotteet tuotantoon";
import Liikemerkki from "./Liikemerkki";
import Haku from "./Haku";
import Ryhmat from "./Ryhmat";
import Sanasto from "./Sanasto";
import NaytaKortit from "./NaytaKortit";
import NaytaTuote from "./NaytaTuote";
import NaytaKori from "./NaytaKori";
import Maksutapa from "./Maksutapa";
import Tilaa from "./Tilaa";
import Kiitos from "./Kiitos";

const App = (props) => {
  function laskeKorttiaSivullaLkm() {
    let korttiaSivulla = 12;
    if (
      detectPointer.fine ||
      (window.innerHeight > 568 && window.innerWidth > 568)
    ) {
      const leveys = window.innerWidth;
      const leveydet = [1036, 936, 753, 678, 520, 0];
      const sarakkeet = [parseInt((leveys - 204) / 208), 3, 3, 2, 2, 1];
      const kortinLeveydet = [200, 200, 175, 175, 150, 150];
      const testi = (e) => leveys >= e;
      const osoitin = leveydet.findIndex(testi);
      const sarakkeita = sarakkeet[osoitin];
      const kortinLeveys = kortinLeveydet[osoitin];
      korttiaSivulla = 3 * sarakkeita;
      document.documentElement.style.setProperty(
        "--pieninKortti",
        kortinLeveys + "px"
      );
    }
    return korttiaSivulla;
  }

  function valitseKortit(tuotteet, alku, lkm) {
    const kortit = tuotteet.slice(alku, alku + lkm);
    kortit.map((tuote) => {
      return tuote.Kuvat.Kuva ? tuote.Kuvat.Kuva : "liikemerkki";
    });
    return kortit;
  }

  function valitseTuotteet(suodattaja = "", osuma = "") {
    let tuotteet = tuotelista;
    const laji =
      window.location.pathname.substr(1, 1) === "f"
        ? (tuote) => tuote.Laji === "Frisbee"
        : (tuote) => tuote.Laji !== "Frisbee";
    const osui = osuma === "" ? (tuote) => tuote.Tuote.includes("") : osuma;
    const suodatin = suodattaja === "" ? (tuote) => tuote.vlkm > 0 : suodattaja;
    tuotteet = tuotteet.filter(laji);
    tuotteet = tuotteet
      .filter(laji)
      .filter(osui)
      .filter(suodatin)
      .sort(function (a, b) {
        if (a.Kuvat.Kuva !== b.Kuvat.Kuva) {
          if (a.Kuvat.Kuva === "liikemerkki") return 1;
          if (b.Kuvat.Kuva === "liikemerkki") return -1;
        }
        return b.mlkm - a.mlkm;
      });
    return tuotteet;
  }

  function alustaTila(alusta = 0) {
    const tila = {};
    tila.frisbee = window.location.pathname.substr(1, 1) === "f";
    if (tila.haku === undefined || alusta) {
      tila.haku = {
        teksti: "",
        ryhmä: "kaikki",
        sivu: 1,
      };
      tila.kori = new Map();
      tila.kori.set("lkm", 0);
    } else {
      tila.haku = JSON.parse(localStorage.getItem("haku"));
      tila.kori = new Map(JSON.parse(localStorage.getItem("kori")));
    }
    tila.korttiLkm = laskeKorttiaSivullaLkm();
    tila.tuotteet = valitseTuotteet();
    tila.kortit = valitseKortit(tila.tuotteet, 0, tila.korttiLkm);
    return tila;
  }
  const alkuTila = alustaTila();

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "kori":
        return { ...state, kori: action.payload };
      case "haku":
        return {
          ...state,
          haku: action.payload.haku,
          korttiLkm: action.payload.korttiLkm,
          kortit: action.payload.kortit,
          tuotteet: action.payload.tuotteet,
        };
      default:
        return { state };
    }
  }, alkuTila);

  useEffect(() => {
    localStorage.setItem("haku", JSON.stringify(state.haku));
    localStorage.setItem("kori", JSON.stringify(Array.from(state.kori)));
  }, [state]);

  function asetatila(toimi, kuorma) {
    let tieto;
    switch (toimi) {
      case "haku":
        tieto = state;
        // sivua 0 käytetään alustukseen
        if (kuorma.sivu === 0) {
          tieto.haku = { teksti: "", ryhmä: "kaikki", sivu: 1 };
        } else {
          tieto.haku.teksti =
            kuorma.teksti !== undefined ? kuorma.teksti : tieto.haku.teksti;
          tieto.haku.ryhmä = kuorma.ryhmä ? kuorma.ryhmä : tieto.haku.ryhmä;
          tieto.haku.sivu = kuorma.sivu ? kuorma.sivu : 1;
        }
        // tuotteiden alustus
        // if (tieto.sivu < 2 || kuorma.sivu === 1) {
        const osui = (tuote) =>
          tuote.Tuote.toLowerCase().includes(tieto.haku.teksti.toLowerCase());
        let suodattaja = (tuote) => tuote.vlkm > 0;
        if (tieto.frisbee) {
          switch (tieto.haku.ryhmä) {
            case "draiverit":
              suodattaja = (tuote) =>
                tuote.vlkm > 0 && tuote.Tyyppi === "Draiveri";
              break;
            case "muut":
              suodattaja = (tuote) =>
                tuote.vlkm > 0 && tuote.Tyyppi !== "Draiveri";
              break;
            default:
              suodattaja = (tuote) => tuote.vlkm > 0;
          }
        } else {
          let kanta = tieto.haku.ryhmä;
          switch (kanta) {
            case "pelivälineet":
              kanta = "1";
              break;
            case "kirjat":
              kanta = "3";
              break;
            default:
              kanta = 0;
          }
          if (kanta)
            suodattaja = (tuote) => tuote.vlkm > 0 && tuote.Kanta === kanta;
        }
        tieto.tuotteet = valitseTuotteet(suodattaja, osui);
        // korttien alustus
        tieto.korttiLkm = laskeKorttiaSivullaLkm();
        tieto.kortit = valitseKortit(
          tieto.tuotteet,
          (tieto.haku.sivu - 1) * tieto.korttiLkm,
          tieto.korttiLkm
        );
        break;
      case "kori":
        tieto = state.kori;
        const tid = kuorma.tid;
        const muutos = kuorma.muutos;
        if (muutos) {
          tieto.set(tid, (parseInt(tieto.get(tid)) || 0) + muutos);
          tieto.set("lkm", parseInt(tieto.get("lkm")) + muutos);
          if (tieto.get(tid) === 0) tieto.delete(tid);
        }
        if (!tid || !tieto.get("lkm")) {
          tieto.clear();
          tieto.set("lkm", 0);
        }
        break;
      default:
        tieto = kuorma;
    }
    dispatch({ type: toimi, payload: tieto });
  }

  function asetaHaku() {
    asetatila("haku", { ryhmä: state.haku.ryhmä });
  }

  useEffect(() => {
    // if (window.location.pathname === "/frisbeeapuri/") {
    window.addEventListener("resize", asetaHaku);
    return (_) => {
      window.removeEventListener("resize", asetaHaku);
    };
    // }
  });
  useEffect(() => {
    // if (window.location.pathname === "/frisbeeapuri/") {
    window.addEventListener("orientationchange", asetaHaku);
    return (_) => {
      window.removeEventListener("orientationchange", asetaHaku);
    };
    // }
  });
  const apuri =
    (window.location.pathname.substring(1, 2) === "f"
      ? "/frisbee"
      : "/tilaus") + "apuri";
  return (
    <Router basename={apuri}>
      <div className="sailio">
        <div className="sailio__liikemerkki">
          <Liikemerkki asetatila={asetatila}></Liikemerkki>
        </div>
        <div className="sailio__haku">
          <Haku tila={state} asetatila={asetatila} />
        </div>
        <div className="sailio__ryhmat">
          <Ryhmat tila={state} asetatila={asetatila} />
        </div>
        <div className="sailio__ruudukko">
          <Routes>
            <Route
              path="/tuote/:kuvaId"
              element={<NaytaTuote tila={state} asetatila={asetatila} />}
            />
            <Route
              path="/kori/:tuoteId"
              element={<NaytaKori tila={state} asetatila={asetatila} />}
            />
            <Route
              path="/kori"
              element={<NaytaKori tila={state} asetatila={asetatila} />}
            />
            <Route path="/sanasto" element={<Sanasto />} />
            <Route path="/maksutapa" element={<Maksutapa />} />
            <Route
              path="/tilaa/:maksutapa"
              element={<Tilaa tila={state} asetatila={asetatila} />}
            />
            <Route path="/kiitos" element={<Kiitos />} />
            <Route
              path="/"
              element={<NaytaKortit tila={state} asetatila={asetatila} />}
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
};
export default App;
